/* eslint-disable max-len */
import React from 'react';

export const CheckCircle = (width = '24', height = '24') => (
  <svg style={{ fill: 'white', 'border-radius': '16px' }} version="1.1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48">
    <title>check-circle</title>
    <path d="M18.259 31.519l18.011-19.203c0.378-0.403 1.011-0.423 1.413-0.045s0.423 1.011 0.045 1.413l-18.759 20c-0.402 0.428-1.084 0.42-1.475-0.018l-7.241-8.106c-0.368-0.412-0.332-1.044 0.079-1.412s1.044-0.332 1.412 0.079l6.514 7.291z" />
  </svg>
);

export const Info = (width = '28', height = '28') => (
  <svg style={{ fill: '#009CDE' }} version="1.1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48">
    <title>info</title>
    <path d="M24 6c9.941 0 18 8.059 18 18s-8.059 18-18 18c-9.941 0-18-8.059-18-18s8.059-18 18-18zM24 8c-8.837 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM23 14.937c0-0.585 0.478-1.063 1.063-1.063s1.063 0.478 1.063 1.063c0 0.585-0.478 1.063-1.063 1.063s-1.063-0.478-1.063-1.063zM23 34v-14.164c0-0.552 0.448-1 1-1s1 0.448 1 1v14.164c0 0.552-0.448 1-1 1s-1-0.448-1-1z" />
  </svg>
);

export const ChevronDown = (width = '32', height = '24') => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48">
    <title>chevron-down</title>
    <path d="M12.707 16.293l11.293 11.293 11.293-11.293c0.391-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-12 12c-0.391 0.391-1.024 0.391-1.414 0l-12-12c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0z" />
  </svg>
);

export const ChevronUp = (width = '32', height = '24') => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48">
    <title>chevron-up</title>
    <path d="M12.707 29.707c-0.391 0.391-1.024 0.391-1.414 0s-0.391-1.024 0-1.414l12-12c0.391-0.391 1.024-0.391 1.414 0l12 12c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0l-11.293-11.293-11.293 11.293z" />
  </svg>
);

export const QuestionAlt = (width = '24', height = '24') => (
  <svg style={{ fill: '#0070BA' }} version="1.1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48">
    <title>question-alt</title>
    <path d="M23.999 2.666c11.781 0 21.333 9.552 21.333 21.333s-9.552 21.333-21.333 21.333c-11.784 0-21.333-9.552-21.333-21.333s9.549-21.333 21.333-21.333zM21.49 37.332h5.333v-5.333h-5.333v5.333zM30.599 23.935c1.763-1.763 2.733-4.107 2.733-6.603 0-2.493-0.971-4.837-2.733-6.6-3.637-3.635-9.56-3.635-13.197 0l-1.885 1.885 3.768 3.773 1.888-1.885c1.56-1.56 4.096-1.56 5.656 0 0.755 0.755 1.171 1.76 1.171 2.827 0 1.069-0.416 2.075-1.171 2.829-0.755 0.757-1.76 1.171-2.829 1.171h-2.667v8h5.333v-3.051c1.472-0.435 2.819-1.235 3.933-2.347z" />
  </svg>
);
